import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { OneLPSsdkParamsContext } from '../../onelps-sdk-params-context';
import styles from '../../css/components/common/alreadyRegisteredLink.css';

export const ALREADY_REGISTERED_LINK_POSITION = {
	HEADER: 'header',
	FORM: 'form',
	ONE_CLICK: 'oneClick',
};

function AlreadyRegisteredLink({ linkText, position, id }) {
	const onelpsParams = useContext(OneLPSsdkParamsContext);

	return (
		<a
			href={onelpsParams.lpsUrl}
			className={`${styles.alreadyRegisteredLink} ${styles[position]}`}
			id={id}
		>
			{linkText}
		</a>

	);
}

export default AlreadyRegisteredLink;

AlreadyRegisteredLink.propTypes = {
	linkText: PropTypes.string.isRequired,
	position: PropTypes.oneOf([
		ALREADY_REGISTERED_LINK_POSITION.FORM,
		ALREADY_REGISTERED_LINK_POSITION.HEADER,
		ALREADY_REGISTERED_LINK_POSITION.ONE_CLICK,
	]).isRequired,
	id: PropTypes.string,
};
